import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const artifactoryOrigin = (window._env_?.ARTIFACTORY_ORIGIN || '').replace(
  /\/$/,
  ''
);
const localesBase = artifactoryOrigin
  ? artifactoryOrigin + '/locales'
  : process.env.PUBLIC_URL + '/locales';

i18n
  // detect available locale files
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    debug: false,
    fallbackLng: window._env_.DEFAULT_LANG, //default language
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: localesBase + '/{{lng}}.json',
      requestOptions: {
        cache: 'no-store',
      },
    },
  });

export default i18n;
